import { Routes } from "@angular/router";

import { AuthGaurd } from "@guards/auth.gaurd";
import { AccessApprovalComponent } from "@pages/access-approval/access-approval.component";
import { LoginComponent } from "@pages/auth/login/login.component";
import { RequestAdminAccessComponent } from "@pages/auth/request-admin-access/request-admin-access.component";
import { CategoryInputComponent } from "@pages/category/category-input/category-input.component";
import { CategoryListComponent } from "@pages/category/category-list/category-list.component";
import { ChangeLogComponent } from "@pages/change-log/change-log.component";
import { ConsumerOutreachComponent } from "@pages/consumer-outreach/consumer-outreach.component";
import { DashboardComponent } from "@pages/dashboard/dashboard.component";
import { FishyOpsAiComponent } from "@pages/fishyops-ai/fishyops-ai.component";
import { MediaUploaderComponent } from "@pages/media-uploader/media-uploader.component";
import { MerchantOrdersComponent } from "@pages/merchant-orders/merchant-orders.component";
import { OrderDetailsComponent } from "@pages/orders/order-details/order-details.component";
import { OrderListComponent } from "@pages/orders/order-list/order-list.component";
import { PendingOrderListPageComponent } from "@pages/orders/pending-order-list-page/pending-order-list-page.component";
import { ProductInputPageComponent } from "@pages/product/product-input/product-input-page.component";
import { ProductListPageComponent } from "@pages/product/product-list/product-list.component";
import { ProductSyncListComponent } from "@pages/product-sync/product-sync-list.component";
import { RecommendationListComponent } from "@pages/recommendation/recommendation-list/recommendation-list.component";
import { UserDetailsComponent } from "@pages/user-details/user-details.component";
import { UserListComponent } from "@pages/user-list/user-list.component";
import { VendorDetailComponent } from "@pages/vendor/vendor-detail/vendor-detail.component";
import { VendorListComponent } from "@pages/vendor/vendor-list/vendor-list.component";
export default [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },

  // static routes
  {
    path: "dashboard",
    canActivate: [AuthGaurd],
    component: DashboardComponent,
  },

  {
    path: "media-uploader",
    canActivate: [AuthGaurd],
    component: MediaUploaderComponent,
  },

  { path: "vendors", canActivate: [AuthGaurd], component: VendorListComponent },
  { path: "access-approval", canActivate: [AuthGaurd], component: AccessApprovalComponent },
  { path: "vendor_input/:id", canActivate: [AuthGaurd], component: VendorDetailComponent },
  { path: "product-sync", canActivate: [AuthGaurd], component: ProductSyncListComponent },
  { path: "fishyops-ai", canActivate: [AuthGaurd], component: FishyOpsAiComponent },

  {
    path: "categories",
    canActivate: [AuthGaurd],
    component: CategoryListComponent,
  },
  {
    path: "category_input/:id",
    canActivate: [AuthGaurd],
    component: CategoryInputComponent,
  },

  {
    path: "products",
    component: ProductListPageComponent,
    canActivate: [AuthGaurd],
  },
  {
    // Redirect-only route: Angular forbids canActivate alongside redirectTo, and the
    // target (products/:merchantId/:categoryId) is already guarded.
    path: "products/:merchantId",
    pathMatch: "full",
    redirectTo: "products/:merchantId/all",
  },
  {
    path: "products/:merchantId/:categoryId",
    canActivate: [AuthGaurd],
    component: ProductListPageComponent,
  },
  {
    path: "product_input/:id",
    canActivate: [AuthGaurd],
    component: ProductInputPageComponent,
  },

  { path: "user_list", canActivate: [AuthGaurd], component: UserListComponent },
  { path: "change-log", canActivate: [AuthGaurd], component: ChangeLogComponent },
  { path: "orders", canActivate: [AuthGaurd], component: OrderListComponent },
  {
    path: "pending-order-list",
    canActivate: [AuthGaurd],
    component: PendingOrderListPageComponent,
  },

  {
    path: "offer",
    canActivate: [AuthGaurd],
    loadChildren: () =>
      import("./pages/offer-list-page/offer-page.routes").then((m) => m.OFFER_ROUTES),
  },

  {
    path: "order_details/:id",
    canActivate: [AuthGaurd],
    component: OrderDetailsComponent,
  },
  {
    path: "consumer-outreach",
    canActivate: [AuthGaurd],
    component: ConsumerOutreachComponent,
  },
  {
    path: "recommendations",
    canActivate: [AuthGaurd],
    component: RecommendationListComponent,
  },
  {
    path: "admin/merchantOrders",
    canActivate: [AuthGaurd],
    component: MerchantOrdersComponent,
  },
  {
    path: "admin/user-details/:id",
    canActivate: [AuthGaurd],
    component: UserDetailsComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "request-admin-access",
    component: RequestAdminAccessComponent,
  },
  {
    path: "auction",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/auction-page/auction-page.routes"),
  },
  {
    path: "banners",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/banners/banner.routes"),
  },
  {
    path: "campaign",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/campaign/campaign.routes"),
  },

  {
    path: "countries",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/country-page/country-page.routes"),
  },
  {
    path: "seo",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/seo-page/seo-page.routes"),
  },
  {
    path: "blogs",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/blogs/blogs.routes"),
  },
  {
    path: "delivery-discount",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/delivery-discount/delivery-discount.routes"),
  },
  {
    path: "tags",
    canActivate: [AuthGaurd],
    loadChildren: () => import("./pages/tags/tags.routes"),
  },
  {
    path: "community",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/community/community-list.component").then((m) => m.CommunityListComponent),
  },
  {
    path: "feed-posts",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/feed-posts/feed-posts-list.component").then((m) => m.FeedPostsListComponent),
  },
  {
    path: "transhippers",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/transhipper/transhipper-list.component").then(
        (m) => m.TranshipperListComponent
      ),
  },
  {
    path: "transhipper_input/:id",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/transhipper/transhipper-detail.component").then(
        (m) => m.TranshipperDetailComponent
      ),
  },
  {
    path: "transhipment",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/transhipment/transhipment.component").then((m) => m.TranshipmentComponent),
  },
  {
    path: "cross-border-restriction",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/cross-border-restriction/cross-border-restriction.component").then(
        (m) => m.CrossBorderRestrictionComponent
      ),
  },
  {
    path: "messages",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/messages/messages.component").then((m) => m.MessagesComponent),
  },
  {
    path: "bulletin",
    canActivate: [AuthGaurd],
    loadComponent: () =>
      import("./pages/bulletin/bulletin.component").then((m) => m.BulletinComponent),
  },
] as Routes;
